module.exports = __webpack_public_path__ + "media/carty.0f34d7b2.webm";